module.exports = __webpack_public_path__ + "img/failure.736bcdf4.png";